import React from 'react'

export const Title = ({children}:{children:any}) => {
  return (
    <div className='subtitle'>
      <span>{children}</span>
    </div>
  )
}

export const H = ({children}:{children:any}) => {
  return (
    <span className='highlighttext'>
      {children}
    </span>
  )
}

export const StateRepresented = {
  stronglyOver: {
    s: 'Stark überrepräsentiert',
    color: '#479260'
  },
  slightlyOver: {
    s:'Überrepräsentiert',
    color: '#479260'
  },
  good : { 
    s: 'Angemessen repräsentiert',
    color: '#479260',
  },
  slightlyUnder : { 
    s: 'Unterrepräsentiert',
    color: '#DE666F',
  },
  stronglyUnder : {
    s: 'Stark unterrepräsentiert',
    color: '#D3343F',
  }
}

export const Represented = ({state}: {state: StateRepresented}) => {
  return (
    <div className='represented'>
      <span style={{backgroundColor: state.color}}>{state.s}</span>
    </div>
  )
}